import React from 'react';

const ViewToggle = ({ viewMode, onViewChange }) => {
  return (
    <div className="view-toggle">
      <button 
        className={`toggle-btn ${viewMode === 'list' ? 'active' : ''}`}
        onClick={() => onViewChange('list')}
        aria-label="Lista vy"
      >
        <span className="toggle-icon">📋</span>
        Lista
      </button>
      <button 
        className={`toggle-btn ${viewMode === 'calendar' ? 'active' : ''}`}
        onClick={() => onViewChange('calendar')}
        aria-label="Kalender vy"
      >
        <span className="toggle-icon">📅</span>
        Kalender
      </button>
    </div>
  );
};

export default ViewToggle;